import { gql } from "@apollo/client";

export const GET_ALL_CLIENTS = gql`
  query GetAllClients {
    home_page_project_client {
      name
      path
    }
  }
`;

export const INSERT_PROJECT_CLIENT = gql`
  mutation InsertProjectClient(
    $object: home_page_project_client_insert_input!
  ) {
    insert_home_page_project_client_one(object: $object) {
      name
      path
    }
  }
`;

export const DELETE_PROJECT_CLIENT = gql`
  mutation DeleteProjectClient($name: String!) {
    delete_home_page_project_client(where: { name: { _eq: $name } }) {
      affected_rows
      returning {
        name
        path
      }
    }
  }
`;
